import { toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-203d3ad8"),n=n(),_popScopeId(),n)
const _hoisted_1 = ["for"]
const _hoisted_2 = {
  key: 0,
  class: "base-input__required"
}
const _hoisted_3 = ["id", "type", "value", "placeholder", "required", "disabled", "readonly", "step", "min", "max"]
const _hoisted_4 = {
  key: 1,
  class: "base-input__error"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["base-input", { 'base-input--has-error': _ctx.hasError }])
  }, [
    (_ctx.label)
      ? (_openBlock(), _createElementBlock("label", {
          key: 0,
          class: "base-input__label",
          for: _ctx.inputId
        }, [
          _createTextVNode(_toDisplayString(_ctx.label) + " ", 1),
          (_ctx.required)
            ? (_openBlock(), _createElementBlock("span", _hoisted_2, "*"))
            : _createCommentVNode("", true)
        ], 8, _hoisted_1))
      : _createCommentVNode("", true),
    _createElementVNode("input", {
      id: _ctx.inputId,
      type: _ctx.type,
      value: _ctx.modelValue,
      placeholder: _ctx.placeholder,
      required: _ctx.required,
      disabled: _ctx.disabled,
      readonly: _ctx.readonly,
      step: _ctx.step,
      min: _ctx.min,
      max: _ctx.max,
      class: "base-input__field",
      onInput: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.handleInput && _ctx.handleInput(...args))),
      onBlur: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.handleBlur && _ctx.handleBlur(...args))),
      onFocus: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.handleFocus && _ctx.handleFocus(...args)))
    }, null, 40, _hoisted_3),
    (_ctx.error)
      ? (_openBlock(), _createElementBlock("div", _hoisted_4, _toDisplayString(_ctx.error), 1))
      : _createCommentVNode("", true)
  ], 2))
}